var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-2 pb-2"},[(_vm.name)?_c('div',{staticClass:"flex w-full items-center px-4 py-2"},[_c('div',{staticClass:"mr-5 w-6 shrink-0"}),_vm._v(" "),_c('div',{staticClass:"w-full text-[0.8em] font-bold uppercase tracking-[1px] text-black"},[_vm._v("\n\t\t\t"+_vm._s(_vm.name)+"\n\t\t")])]):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }